import { Page } from "@/models/page-models/Page";

export const SparePartsReceipt: Page = {
  "path": "spare-parts-receipt",
  "name": "Receive Spare Parts",
  "props": {
    "data": {
      "title": "Receive Spare Parts",
      "printable": "FALSE",
      "url": "spare-parts-receipt",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.forPO",
                  "label": "Purchase Order",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyPoData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "initialiseReceipts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.posPendingReceipts.data",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,purchaseOrder,{{__item}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData._id",
                  "label": "PO#",
                  "showIf": "{{formData.forPO}}"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData.updatedAt",
                  "label": "PO Date",
                  "showIf": "{{formData.forPO}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.selectedPoData.updatedAt}})"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData.supplier.name",
                  "label": "Supplier",
                  "showIf": "{{formData.forPO}}"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.receivedSpareParts",
          "label": "Received Spare Parts",
          "disabled": "FALSE",
          "showIf": "{{formData.receivedSpareParts}}",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "id",
                  "label": "Spare Part",
                  "disabled": "TRUE",
                  "items": "fetchedData.allSpareParts.data",
                  "itemText": "description",
                  "itemValue": "_id"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Quantity",
                  "labelType": "formula",
                  "formula": "{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}}",
                  "filterType": "unit",
                  "filterParam": "{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.sparePart.unit}}"
                },
                {
                  "type": "label",
                  "variable": "receivedQuantity",
                  "label": "Received Quantity",
                  "labelType": "formula",
                  "formula": "{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}}",
                  "filterType": "unit",
                  "filterParam": "{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.sparePart.unit}}"
                },
                {
                  "type": "label",
                  "variable": "balanceQuantity",
                  "label": "Balance Quantity",
                  "labelType": "formula",
                  "formula": "fn(SUBTRACT,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}})",
                  "filterType": "unit",
                  "filterParam": "{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.sparePart.unit}}"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "entries",
                  "label": "Spare Parts",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "weight",
                          "label": "Quantity",
                          "disabled": "FALSE"
                        },
                        {
                          "type": "input",
                          "variable": "id",
                          "label": "Roll #/Pallet #",
                          "disabled": "FALSE"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "disableAddDelete": true
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Receive Spare Part",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "submitSparePartsReceipt"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPosPendingReceipts"
      },
      {
        "executionOrder": 1,
        "name": "getAllSpareParts"
      }
    ],
    "functions": [
      {
        "name": "getPosPendingReceipts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/checkWarehouse?type=Spare Parts",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.posPendingReceipts"
      },
      {
        "name": "copyPoData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPoData"
      },
      {
        "name": "initialiseReceipts",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.selectedPoData.purchasedRMs",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.receivedSpareParts",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "createInitialMaterialData"
      },
      {
        "name": "createInitialMaterialData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__selectedObject.sparePart._id}}",
          "entries": "[{}]"
        },
        "useFormula": true
      },
      {
        "name": "submitSparePartsReceipt",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/purchaseorder/sparePartReceipt",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getAllSpareParts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/sparepart",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.allSpareParts"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": true
}